import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaHeadset } from 'react-icons/fa';
import { motion } from 'framer-motion';
import admissionDefault from '../../../../data/admission/admission.json';

// Icon key → component.
const SUPPORT_ICONS = { phone: FaPhoneAlt, email: FaEnvelope, pin: FaMapMarkerAlt };

const AdmissionSupport = ({ data }) => {
    const d = data || admissionDefault.support;
    const items = d.items || [];

    return (
        <Paper
            component={motion.div}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            elevation={0}
            sx={{
                width: '100%',
                height: '100%',
                p: { xs: 3, md: 4 },
                borderRadius: '20px',
                background: '#ffffff',
                border: '1px solid #E2E8F0',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                <Box sx={{ width: 44, height: 44, borderRadius: '12px', background: 'rgba(246,135,42,0.1)', color: '#F6872A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FaHeadset size="18px" />
                </Box>
                <Typography sx={{ fontWeight: 900, fontSize: '1.3rem', color: '#0e2455', letterSpacing: '-0.3px' }}>
                    {d.heading}
                </Typography>
            </Box>

            <Typography sx={{ fontSize: '0.92rem', color: '#64748B', lineHeight: 1.6 }}>
                {d.intro}
            </Typography>

            <Box sx={{ mt: 2.5 }}>
                {items.map((it, i) => {
                    const inner = (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1.75, borderTop: i === 0 ? 'none' : '1px solid #F1F5F9' }}>
                            <Box sx={{ flexShrink: 0, width: 34, height: 34, borderRadius: '10px', background: 'rgba(246,135,42,0.1)', color: '#F6872A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {React.createElement(SUPPORT_ICONS[it.icon] || FaPhoneAlt, { size: '13px' })}
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography sx={{ fontSize: '0.6rem', fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#94A3B8' }}>
                                    {it.label}
                                </Typography>
                                <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#0e2455', wordBreak: 'break-word', lineHeight: 1.3 }}>
                                    {it.value}
                                </Typography>
                            </Box>
                        </Box>
                    );

                    return it.href ? (
                        <Box key={i} component="a" href={it.href} sx={{ display: 'block', textDecoration: 'none', transition: 'opacity 0.2s ease', '&:hover': { opacity: 0.65 } }}>
                            {inner}
                        </Box>
                    ) : (
                        <Box key={i}>{inner}</Box>
                    );
                })}
            </Box>
        </Paper>
    );
};

export default AdmissionSupport;
